import React, { FC } from 'react';
import styled from 'styled-components';

import { AmountInput, CurrenciesUSD } from '@column/column-ui-kit';

import { FormField } from '~/components/FormField';
import { UserTransferFilterSnapshot } from '~/repositories';

const Fields = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;
`;

const Row = styled.div`
  grid-column: 1 / 3;
`;

export const TransferAmountFilter: FC = () => {
  return (
    <Fields>
      <Row>
        <FormField<UserTransferFilterSnapshot> id="filters.amount" label=" Transfer Amount" oneColumn>
          {({ value, onChange, onBlur }, { isTouched, error }) => (
            <AmountInput
              currencyList={CurrenciesUSD}
              fixedCurrencyCode="USD"
              hasError={isTouched && !!error}
              value={Number(value ?? '')}
              onChange={(v) => (v ? onChange(v?.toString() ?? '') : onChange(null))}
              onBlur={onBlur}
            />
          )}
        </FormField>
      </Row>
      <FormField<UserTransferFilterSnapshot> id="filters.amountGte" label="Minimum Transfer Amount" oneColumn>
        {({ value, onChange, onBlur }, { isTouched, error }) => (
          <AmountInput
            currencyList={CurrenciesUSD}
            fixedCurrencyCode="USD"
            hasError={isTouched && !!error}
            value={Number(value ?? '')}
            onChange={(v) => (v ? onChange(v?.toString() ?? '') : onChange(null))}
            onBlur={onBlur}
          />
        )}
      </FormField>
      <FormField<UserTransferFilterSnapshot> id="filters.amountLte" label="Maximum Transfer Amount" oneColumn>
        {({ value, onChange, onBlur }, { isTouched, error }) => (
          <AmountInput
            currencyList={CurrenciesUSD}
            fixedCurrencyCode="USD"
            hasError={isTouched && !!error}
            value={Number(value ?? '')}
            onChange={(v) => (v ? onChange(v?.toString() ?? '') : onChange(null))}
            onBlur={onBlur}
          />
        )}
      </FormField>
    </Fields>
  );
};
